import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    ADD_AFS_LICENCE: (afsLicence) => ({ afsLicence }),
    API: {
      ADD_AFS_LICENCE: apiResourceActionCreator('afsLicence')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.AfsLicences), authToken, payload, actions.user.api.addAfsLicence)

const configuration = {
  name: 'addAfsLicence',
  action: actions,
  sagas: undefined,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      // Currently we only allow ONE AFSL to be associated to an user.
      // But it is built with potentially have multiple AFSLs.
      // Update this if we start allowing multile AFSL associations.
      currentUserAfsLicences: [action.payload.afsLicence],
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/addAfsLicence.js